<template>
  <DeferredContent @onLoadComponent="handleFetchTeamProgress">
    <div
      class="w-full flex flex-col gap-4"
      :class="{
        'pt-4 mt-4 border-t border-untitled-gray-200': showBorder,
      }"
    >
      <div class="flex items-center gap-2">
        <div
          class="flex items-center justify-center w-8 h-8 rounded-lg bg-app-secondary/10 text-app-secondary shrink-0"
        >
          <UserGroupIcon class="w-4 h-4" />
        </div>
        <div>
          <h3 class="text-sm sm:text-base font-semibold text-untitled-gray-900">
            Your Team’s Progress
          </h3>
          <p class="text-xs text-untitled-gray-500">
            A quick snapshot of your team's learning activity.
          </p>
        </div>
      </div>

      <ul
        role="list"
        class="lms-widget-grid w-full"
        v-if="!loadingProgress && teamProgress.length && !isErrorTeamProgress"
      >
        <V4TeamProgressCard
          v-for="report in teamProgress"
          :key="report.key"
          :text="report.title"
          :value="report.value"
          :id="report.key"
          :description="wrapTooltipContent(report.description)"
        />
      </ul>

      <V4LoadingTeamProgressCards v-if="loadingProgress" />

      <MessageContainer
        v-if="!loadingProgress && isErrorTeamProgress"
        text="There was a problem loading your team's progress."
        class="min-h-32 border border-untitled-gray-200 rounded-xl bg-white"
      >
        <button
          type="button"
          class="inline-flex items-center gap-1.5 text-sm font-medium text-app-primary hover:text-app-primary/80 transition-colors"
          @click="handleFetchTeamProgress"
        >
          <CursorClickIcon class="w-4 h-4" />
          Reload
        </button>
      </MessageContainer>
    </div>
  </DeferredContent>
</template>

<script setup>
import { computed, onMounted, watch, defineProps } from "vue";
import { useTeamProgressStore } from "@/stores/home/useTeamProgress.store";
import { useAuthStore } from "@/stores";
import DeferredContent from "@/components/utilities/DeferredContent.vue";
import { storeToRefs } from "pinia";
import { wrapTooltipContent } from "@/composable/wrapTooltipContent";
import MessageContainer from "@/components/utilities/MessageContainer.vue";
import { CursorClickIcon } from "@heroicons/vue/solid";
import { UserGroupIcon } from "@heroicons/vue/outline";
import V4TeamProgressCard from "./partials/V4TeamProgressCard.vue";
import V4LoadingTeamProgressCards from "./V4LoadingTeamProgressCards.vue";

defineProps({
  showBorder: {
    type: Boolean,
    default: true,
  },
});

const teamProgressStore = useTeamProgressStore();
const authStore = useAuthStore();
const { loadingProgress, isErrorTeamProgress } = storeToRefs(teamProgressStore);

const teamProgress = computed(() => teamProgressStore.progress);

const handleFetchTeamProgress = () => {
  teamProgressStore.handleFetchAssignedSummary();
};

const isActingAsTeamLeader = computed(() => authStore.is_acting_as_team_leader);

watch(isActingAsTeamLeader, handleFetchTeamProgress);

onMounted(handleFetchTeamProgress);
</script>

<style lang="scss" scoped></style>
